// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"dam-3"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 21V10C4 5.02944 8 2 12 2C16 2 20 5.02944 20 10V21H16V10H8V21H4Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 21V10C4 5.02944 8 2 12 2C16 2 20 5.02944 20 10V21M4 21H3M4 21H8M20 21H21M20 21H16M8 10V21M8 10H16M8 10H4.25M8 21H9M16 10V21M16 10H19.75M16 21H15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M11 6H13","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Dam3Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dam-3',
    ref,
    icon: element,
  },
));

Dam3Icon.displayName = 'Dam3Icon';

export default Dam3Icon;
